/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlColor1 = {
    Gray: 'gray',
    Red: 'red',
    Orange: 'orange',
    Amber: 'amber',
    Green: 'green',
    Teal: 'teal',
    Blue: 'blue',
    Indigo: 'indigo',
    Purple: 'purple',
    Pink: 'pink'
} as const;
export type ControlColor1 = typeof ControlColor1[keyof typeof ControlColor1];


export function ControlColor1FromJSON(json: any): ControlColor1 {
    return ControlColor1FromJSONTyped(json, false);
}

export function ControlColor1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlColor1 {
    return json as ControlColor1;
}

export function ControlColor1ToJSON(value?: ControlColor1 | null): any {
    return value as any;
}

